export enum AttachmentStatus {
  PENDING = 'pending',
  ATTACHED = 'attached',
  PROGRESS = 'progress',
  UNSUPPORTED = 'unsupported',
  DISABLED = 'disabled',
  EXCLUDED = 'excluded',
  ERROR = 'error'
}
